import "./customButton.css";
import NavbarLocation from "../../Pages/NavbarLocation/NavbarLocation";
import Button from "../../Custom/Button/Button";

const CustomButton = ({
  buttonPictureActive,
  navbarButton,
  buttonPictureNonActive,
  data,
  handleActiveNavbar,
  handleData,
  clickNavbar,
  index,
  timeUnlockCurrent,
  isBothMinimize,
}) => {
  const setClassName = () => {
    if (data.length > 3) {
      if (isBothMinimize) return "button-navbar";
      else if (clickNavbar.value) {
        return "button-navbar";
      } else return "button-navbar not-visible";
    } else {
      return "button-navbar not-clickable";
    }
  };

  console.log(data);
  return (
    <div className={setClassName()}>
      <Button active={clickNavbar.value}>
        <div
          className="wraper-name-button"
          onClick={() => handleActiveNavbar()}
        >
          {data.length > 1 && (
            <div className={`${data.length < 3 ? "name many" : "name"}`}>
              {navbarButton[index].name}
            </div>
          )}
          {data.length > 3 ? (
            <div className="wraper-location-button">
              {clickNavbar.value && (
                <NavbarLocation
                  index={index}
                  location={data}
                  buttonPictureNonActive={buttonPictureNonActive}
                  buttonPictureActive={buttonPictureActive}
                  handleData={handleData}
                />
              )}
            </div>
          ) : (
            <>
              {data.length !== 0 &&
                (data.length === 1 ? (
                  <div className="wraper-location-button single">
                    <div
                    style={{ border: "none" }}
                      className={
                        timeUnlockCurrent
                          ? "location-button"
                          : "location-button not-clickable"
                      }
                      onClick={() => handleData(data[0], index)}
                    >
                      <div
                        style={{ fontSize: "4.5vh", fontWeight: "600" }}
                        active={data[0].active}
                      >
                        {data[0].name.toUpperCase()}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="wraper-location-button many">
                    {data.map((item, i) => {
                      const { active } = data;
                      console.log(data);
                      return (
                        <div
                          key={i}
                          className={
                            timeUnlockCurrent
                              ? "location-button"
                              : "location-button not-clickable"
                          }
                          onClick={() => handleData(item, index, i)}
                        >
                          <Button active={active}>{item.name}</Button>
                        </div>
                      );
                    })}
                  </div>
                ))}
            </>
          )}
        </div>
      </Button>
    </div>
  );
};

export default CustomButton;
